import {makeReactContext} from 'lib/makeReactContext';

export interface BenchlingChartProperties {
  clientId: string;
  width: number;
  height: number;
}

export const BenchlingChartContext = makeReactContext<BenchlingChartProperties>(() => {
  throw new Error('Could not find BenchlingChartContext during rendering');
}, 'BenchlingChartContext');

export const useBenchlingChartContext = BenchlingChartContext.useContext;
